<div class="project-container">

  <div class="page-title-box">
    <div style="color: #DEDEDE;font-size:18px;">Projects</div>
    <div class="flex ">

      <div class="switch-button-group ml_20" fxLayout="row" fxLayoutAlign="center center">
        <div class="block_box" fxLayout="row" fxLayoutAlign="center center"
             [ngClass]="{'active':  layout == 'list'}" (click)="layout='list'">
          <img src="./assets/images/black/list_{{layout}}.png" class="list_image">
        </div>
        <div class="block_box" fxLayout="row" fxLayoutAlign="center center"
             [ngClass]="{'active':  layout == 'grid'}" (click)="layout='grid'">
          <img src="./assets/images/black/block_{{layout}}.png" class="list_image">
        </div>
      </div>
    </div>
  </div>
  <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-top: 30px;">
    <div class="box">
      <img src="./assets/images/black/search.png" style="width:20px;height: 20px;margin-left: 12px;">
      <input class="find_input" placeholder="Search for projects" #projectSearchInput>
    </div>

    <div fxLayout="row" fxLayoutGap="12px">
      <!-- routerLink="/projects/new-project" -->
      <button *ngIf="highestRole.weight >= 1000" class="new" mat-button (click)="addProject()">
        Create Project
      </button>
    </div>
  </div>

  <!-- Show loading indicator while project list is being fetched -->
  <ng-container *ngIf="isLoading; else projectsLoaded">
    <app-loading style="height: 100vh;"></app-loading>
  </ng-container>

  <ng-template #projectsLoaded>
    <div *ngIf="(projects$ != null)" class="mt_30 page-content">
      <div style="color: rgba(222, 222, 222, 0.6);font-size:16px;margin-bottom: 16px;">All Projects</div>
      <!-- Use a simple container for list layout so height grows with content -->
      <div *ngIf="layout != 'grid'" style="width: 100%">
        <div *ngFor="let project of projects$" class="mb_20">
          <app-project-item [layout]="layout" [project]="project" [id]="project.id" style="flex-grow: 1;">
          </app-project-item>
        </div>
      </div>
      <app-dashboard *ngIf="layout === 'grid'"></app-dashboard>
      <!-- Pagination controls (list layout only) -->

    </div>
  </ng-template>

  <div *ngIf="layout !== 'grid' && !isLoading" class="paginator-footer" fxLayout="row" fxLayoutAlign="end center">
    <mat-paginator
      [length]="total"
      [pageIndex]="page"
      [pageSize]="pageSize"
      [pageSizeOptions]="[5, 10, 20, 50]"
      [showFirstLastButtons]="true"
      (page)="onPageChange($event)">
    </mat-paginator>
  </div>
</div>
